/**
 * Gets user's preferred language from browser.
 */
export default function() {
  return navigator.language || navigator.userLanguage;
}
